export default "__VITE_ASSET__f1c8f4fd__"